import _bindInstanceProperty from "@babel/runtime-corejs3/core-js/instance/bind";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { g } from "xojs/lib/runtime/getGlobal"; // eslint-disable-next-line func-style

function getPlaceDetails() {
  var _this = this;

  return new _Promise(function (resolve, reject) {
    _this.placesService.getDetails({
      placeId: _this.placeId,
      sessionToken: _this.sessionToken,
      fields: _this.fields
    }, function (place, status) {
      var OK = g.google.maps.places.PlacesServiceStatus.OK;

      if (status !== OK) {
        return reject(status);
      }

      return resolve(place);
    });
  }).then(function (place) {
    _this.placeDetails = place;
  });
}

export default (function (_ref) {
  var placeId = _ref.placeId,
      map = _mapInstanceProperty(_ref),
      sessionToken = _ref.sessionToken,
      fields = _ref.fields;

  var context = {
    placeId: placeId,
    placesService: new g.google.maps.places.PlacesService(map),
    placeDetails: null,
    sessionToken: sessionToken,
    fields: fields
  };
  return _Promise.resolve().then(_bindInstanceProperty(getPlaceDetails).call(getPlaceDetails, context)).then(function () {
    return context.placeDetails;
  });
});